/* eslint-disable jsx-a11y/anchor-is-valid */
//Import Scss
import "./assets/scss/themes.scss";
import { useCheckVersion } from "./hooks/useCheckVersion";
import { Alert } from "reactstrap";
import Routes from "./routes/";
import Hotjar from "@hotjar/browser";
import ErrorBoundary from "./components/ErrorBoundary";
import "./lib/chartjs-setup";
import { useNetworkQuality } from "./hooks/useNetworkQuality";
import NetworkBanner from "./components/NetworkBanner";

// const siteId = 6390165; // STG
const siteId = 6383280; // PROD

const hotjarVersion = 6;

function App() {
  const stale = useCheckVersion({ intervalMs: 5 * 60 * 1000 }); // checa a cada 5 minutos
  Hotjar.init(siteId, hotjarVersion);

  const { status, lastRtt } = useNetworkQuality({
    assetUrl: "/ping.txt", // arquivo estático em /public
    intervalMs: 10000, // 10 segundos
    timeoutMs: 5000,
    hysteresis: 2,
    slowRttMs: 800,
  });

  return (
    <>
      <NetworkBanner status={status} lastRtt={lastRtt} />
      {stale && (
        <Alert color="warning" className="text-center mb-0">
          Há uma nova versão disponível.{" "}
          <a href="#" onClick={() => window.location.reload()} style={{ fontWeight: "bold", color: "red" }}>
            Clique aqui para recarregar o sistema
          </a>
          .
        </Alert>
      )}
      <ErrorBoundary>
        <Routes />
      </ErrorBoundary>
    </>
  );
}

export default App;
